import { ValidationSchema } from '../../../../../@types/validation-types'
import {
  defaultConnections,
  defaultContactInfo,
  defaultCosts,
  defaultGastronomyBasicInfo,
  defaultGastronomyOtherFacilities,
  useManualAndInternationalAddress,
} from '../../../../../services/validation/flow/defaultSchemas'
import { validationRules } from '../../../../../services/validation/rules/validationRules'

export const tenantGastronomyRentSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  basicInfo: defaultGastronomyBasicInfo,
  costs: defaultCosts,
  description: {
    adTitle: validationRules.adTitle,
    adDescription: validationRules.adDescription,
    adLocation: validationRules.adLocation,
  },
  otherFacilities: defaultGastronomyOtherFacilities,
  contactInfo: defaultContactInfo,
  connections: defaultConnections,
}
